import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Kiacarenceonrentinpune() {



    const cardData = {

keyword: "Kia Carens On Rent in Pune",

headingDescription:
    "Rising Cab Service offers comfortable and reliable Kia Carens On Rent in Pune for family trips, airport transfers, corporate travel, weekend getaways, and outstation journeys. The Kia Carens is a premium 6–7 seater MPV designed with spacious interiors, captain seat options, powerful AC, smooth suspension, and modern comfort features. With well-maintained vehicles, experienced chauffeurs, doorstep pickup across Pune, flexible rental plans, one-way and round-trip services, 24/7 availability, and transparent pricing, we ensure a safe and premium travel experience for families and small groups.",

topPlaces: [
   
    {
        title: "Mahabaleshwar & Panchgani Tour",
        description:
            "Mahabaleshwar and Panchgani are famous hill stations known for strawberry farms, lakes, viewpoints, and cool climate. Kia Carens provides a spacious and smooth travel experience for families exploring nature, sightseeing spots, and peaceful hill environments."
    },
    {
        title: "Shirdi Sai Baba Darshan",
        description:
            "Shirdi is one of the most important pilgrimage destinations in Maharashtra dedicated to Sai Baba. Kia Carens is ideal for family darshan trips, offering comfort, space, and a relaxed highway journey from Pune for devotees visiting the holy shrine."
    },
    {
        title: "Nashik & Trimbakeshwar Jyotirlinga",
        description:
            "Nashik is a spiritual city known for Trimbakeshwar Jyotirlinga, Panchavati temples, and vineyards. Kia Carens is perfect for small group travel combining pilgrimage and leisure experiences from Pune with premium comfort and smooth driving."
    },
    {
        title: "Pune Airport Transfers",
        description:
            "Kia Carens is widely preferred for Pune airport pickup and drop services due to its spacious cabin, luggage capacity, and comfort features. It ensures timely and hassle-free transfers for families and business travelers."
    },
    {
        title: "Alibaug Beach Weekend Trip",
        description:
            "Alibaug is a coastal destination near Mumbai known for beaches, forts, and water sports. Kia Carens is perfect for family weekend trips and beach vacations from Pune, offering comfort and a relaxed travel experience throughout the journey."
    },
    {
        title: "Bhimashankar Jyotirlinga Visit",
        description:
            "Bhimashankar is a sacred Jyotirlinga temple located in the Sahyadri hills surrounded by forests. Kia Carens provides a safe, smooth, and comfortable journey for devotees and nature lovers traveling from Pune."
    },
     {
        title: "Lonavala & Khandala Hill Escape",
        description:
            "Lonavala and Khandala are the most popular weekend destinations near Pune, known for lush green valleys, waterfalls, and scenic viewpoints. Kia Carens offers a premium and comfortable ride for families and small groups enjoying monsoon drives, short trips, and relaxing hill station getaways."
    },
    {
        title: "Ashtavinayak Darshan Circuit",
        description:
            "The Ashtavinayak pilgrimage includes eight sacred Ganpati temples across Maharashtra. Kia Carens is suitable for small family spiritual tours, offering comfort, flexibility, and smooth travel from Pune."
    },
    {
        title: "Lavasa Hill City Tour",
        description:
            "Lavasa is a scenic planned hill city near Pune known for lakeside views, architecture, and relaxing drives. Kia Carens is ideal for short family leisure trips with a comfortable and enjoyable travel experience."
    },
    {
        title: "Outstation Family Travel",
        description:
            "Kia Carens is a popular choice for outstation travel from Pune due to its comfort, safety, and premium feel. It is ideal for short and medium-distance family trips across Maharashtra and nearby states."
    }
],



services: [
{
name: "Kia Carens On Rent in Pune",
description: "Rising Cab Service offers Kia Carens On Rent in Pune for family trips, airport transfers, corporate travel, sightseeing tours, and outstation journeys. The Kia Carens is a spacious and premium 7-seater MPV that provides excellent comfort, modern interiors, ample luggage space, and a smooth travel experience. We offer professional drivers, affordable rental packages, doorstep pickup, flexible travel schedules, and 24x7 customer support for hassle-free transportation."
},
{
name: "Kia Carens Rental Pune",
description: "Book Kia Carens Rental Pune with Rising Cab Service for comfortable local and outstation travel. Our well-maintained Kia Carens vehicles are perfect for family vacations, business travel, group outings, and airport transfers with experienced chauffeurs and affordable pricing."
},
{
name: "Kia Carens Cab Service Pune",
description: "Rising Cab Service provides Kia Carens Cab Service Pune with professional drivers, clean interiors, and comfortable seating. Whether you need local travel, city sightseeing, or long-distance transportation, our Kia Carens cabs ensure a safe and enjoyable journey."
},
{
name: "Kia Carens Taxi Booking Pune",
description: "Kia Carens Taxi Booking Pune offers easy reservations, transparent pricing, and instant booking confirmation. Enjoy comfortable travel with experienced drivers and flexible rental options for every travel requirement."
},
{
name: "Kia Carens Car Rental Pune",
description: "Choose Kia Carens Car Rental Pune for spacious and reliable transportation. Ideal for families, tourists, and corporate travelers seeking premium comfort and dependable travel solutions."
},
{
name: "Kia Carens Cab Hire Pune",
description: "Book Kia Carens Cab Hire Pune with Rising Cab Service for local travel, outstation trips, airport transfers, and holiday tours. We provide well-maintained vehicles and professional chauffeur services."
},
{
name: "Kia Carens Outstation Cab Pune",
description: "Kia Carens Outstation Cab Pune is ideal for destinations like Mahabaleshwar, Shirdi, Lonavala, Nashik, Mumbai, Goa, and other tourist locations. Enjoy comfortable seating, AC travel, and safe long-distance transportation."
},
{
name: "Kia Carens Airport Cab Pune",
description: "Rising Cab Service offers Kia Carens Airport Cab Pune with timely airport pickups and drop-offs. Our service includes flight monitoring, luggage assistance, and comfortable travel arrangements."
},
{
name: "Kia Carens One Way Cab Pune",
description: "Book Kia Carens One Way Cab Pune for affordable drop-only transportation. We offer transparent pricing, professional drivers, and comfortable vehicles for convenient one-way travel."
},
{
name: "Kia Carens Round Trip Cab Pune",
description: "Kia Carens Round Trip Cab Pune provides flexible return travel options, waiting facilities, and comfortable transportation for vacations, business trips, and sightseeing tours."
},
{
name: "Kia Carens AC Cab Pune",
description: "Choose Kia Carens AC Cab Pune for comfortable local and outstation travel. Our air-conditioned vehicles ensure a pleasant journey throughout the year."
},
{
name: "Online Kia Carens Booking Pune",
description: "Online Kia Carens Booking Pune allows quick reservations, instant confirmation, and convenient booking support. Enjoy a seamless cab booking experience with Rising Cab Service."
},
{
name: "Kia Carens Family Cab Pune",
description: "Kia Carens Family Cab Pune is perfect for family vacations, religious tours, airport transfers, and weekend getaways. The spacious seating arrangement ensures a comfortable ride for all passengers."
},
{
name: "Kia Carens 7 Seater Rental Pune",
description: "Book Kia Carens 7 Seater Rental Pune for group travel, family outings, and long-distance journeys. Enjoy ample luggage space, comfortable seating, and reliable chauffeur service."
},
{
name: "Kia Carens Tourist Cab Pune",
description: "Kia Carens Tourist Cab Pune offers comfortable transportation for sightseeing tours, holiday packages, and weekend trips. Travel conveniently with experienced drivers and premium vehicles."
},
{
name: "Corporate Kia Carens Cab Pune",
description: "Rising Cab Service provides Corporate Kia Carens Cab Pune for employee transportation, business meetings, airport transfers, conferences, and executive travel requirements."
},
{
name: "Affordable Kia Carens Rental Pune",
description: "Affordable Kia Carens Rental Pune offers budget-friendly travel solutions without compromising comfort and service quality. Ideal for family travel, local trips, and outstation journeys."
},
{
name: "Luxury Kia Carens Rental Pune",
description: "Experience premium travel with Luxury Kia Carens Rental Pune. Enjoy modern interiors, spacious seating, professional chauffeur service, and a comfortable journey for every occasion."
},
{
name: "Kia Carens Car Hire Pune",
description: "Kia Carens Car Hire Pune provides flexible rental packages for airport transfers, family vacations, sightseeing tours, and business travel with dependable service and affordable rates."
},
{
name: "Kia Carens on Rent Pune",
description: "Book Kia Carens on Rent Pune with Rising Cab Service and enjoy spacious interiors, comfortable seating, AC comfort, and professional driver support for local and outstation travel."
},
{
name: "Kia Carens Taxi Service Pune",
description: "Kia Carens Taxi Service Pune offers reliable transportation solutions for daily travel, airport pickups, corporate requirements, and long-distance journeys with experienced chauffeurs."
},
{
name: "Kia Carens Cab Booking Pune",
description: "Kia Carens Cab Booking Pune provides quick online reservations, transparent pricing, and multiple travel options to meet your transportation requirements efficiently."
},
{
name: "7 Seater Kia Carens Rental Pune",
description: "7 Seater Kia Carens Rental Pune is an excellent choice for families and groups seeking spacious, comfortable, and affordable transportation for local and outstation trips."
},
{
name: "Kia Carens Outstation Taxi Pune",
description: "Book Kia Carens Outstation Taxi Pune for comfortable travel to tourist destinations, religious places, hill stations, and business locations across Maharashtra and neighboring states."
},
{
name: "Kia Carens Family Car Rental Pune",
description: "Kia Carens Family Car Rental Pune offers spacious and convenient travel for family vacations, weddings, pilgrimages, and holiday tours with professional drivers."
},
{
name: "Kia Carens Airport Transfer Pune",
description: "Choose Kia Carens Airport Transfer Pune for timely airport transportation, luggage assistance, and comfortable travel with experienced chauffeurs."
},
{
name: "Pune Kia Carens Car Hire",
description: "Pune Kia Carens Car Hire provides premium transportation for local sightseeing, business travel, airport transfers, and long-distance journeys with reliable customer support."
},
{
name: "Kia Carens Online Cab Booking Pune",
description: "Kia Carens Online Cab Booking Pune allows easy reservation, instant confirmation, and secure booking support for all local and outstation travel requirements."
},
{
name: "Kia Carens On Rent in Hinjewadi Pune",
description: "Rising Cab Service offers Kia Carens On Rent in Hinjewadi Pune for IT professionals, families, airport transfers, and outstation trips with comfortable travel solutions."
},
{
name: "Kia Carens On Rent in Kharadi Pune",
description: "Book Kia Carens On Rent in Kharadi Pune for convenient local and long-distance travel with professional drivers, clean vehicles, and affordable rental packages."
},
{
name: "Kia Carens On Rent in Hadapsar Pune",
description: "Kia Carens On Rent in Hadapsar Pune is available for family outings, airport transportation, business travel, and sightseeing tours with flexible booking options."
},
{
name: "Kia Carens On Rent in Baner Pune",
description: "Choose Kia Carens On Rent in Baner Pune for comfortable and reliable transportation with spacious seating, AC comfort, and experienced chauffeur service."
},
{
name: "Kia Carens On Rent in Wakad Pune",
description: "Kia Carens On Rent in Wakad Pune provides affordable travel solutions for airport transfers, family vacations, corporate travel, and outstation journeys."
},
{
name: "Kia Carens On Rent in Pimpri Chinchwad",
description: "Book Kia Carens On Rent in Pimpri Chinchwad for group travel, family tours, local transportation, and outstation trips with dependable service and affordable pricing."
},
{
name: "Kia Carens On Rent in Viman Nagar Pune",
description: "Kia Carens On Rent in Viman Nagar Pune offers premium transportation for airport transfers, business meetings, sightseeing tours, and family travel."
},
{
name: "Kia Carens On Rent in Kothrud Pune",
description: "Rising Cab Service provides Kia Carens On Rent in Kothrud Pune with comfortable seating, professional drivers, and customized travel packages for all travel needs."
},
{
name: "Kia Carens On Rent in Magarpatta Pune",
description: "Book Kia Carens On Rent in Magarpatta Pune for local travel, corporate transportation, airport transfers, and long-distance journeys with reliable support."
},
{
name: "Kia Carens On Rent in Wagholi Pune",
description: "Kia Carens On Rent in Wagholi Pune is available for family trips, holiday tours, business travel, and airport transportation with comfortable vehicles and professional chauffeurs."
}
],

tableData: [
["Kia Carens On Rent in Pune","Kia Carens Rental Pune"],
["Kia Carens Cab Service Pune","Kia Carens Taxi Booking Pune"],
["Kia Carens Car Rental Pune","Kia Carens Cab Hire Pune"],
["Kia Carens Outstation Cab Pune","Kia Carens Airport Cab Pune"],
["Kia Carens One Way Cab Pune","Kia Carens Round Trip Cab Pune"],
["Kia Carens AC Cab Pune","Online Kia Carens Booking Pune"],
["Kia Carens Family Cab Pune","Kia Carens 7 Seater Rental Pune"],
["Kia Carens Tourist Cab Pune","Corporate Kia Carens Cab Pune"],
["Affordable Kia Carens Rental Pune","Luxury Kia Carens Rental Pune"],
["Kia Carens Car Hire Pune","Kia Carens on Rent Pune"],
["Kia Carens Taxi Service Pune","Kia Carens Cab Booking Pune"],
["7 Seater Kia Carens Rental Pune","Kia Carens Outstation Taxi Pune"],
["Kia Carens Family Car Rental Pune","Kia Carens Airport Transfer Pune"],
["Pune Kia Carens Car Hire","Kia Carens Online Cab Booking Pune"],
["Kia Carens On Rent in Hinjewadi Pune","Kia Carens On Rent in Kharadi Pune"],
["Kia Carens On Rent in Hadapsar Pune","Kia Carens On Rent in Baner Pune"],
["Kia Carens On Rent in Wakad Pune","Kia Carens On Rent in Pimpri Chinchwad"],
["Kia Carens On Rent in Viman Nagar Pune","Kia Carens On Rent in Kothrud Pune"],
["Kia Carens On Rent in Magarpatta Pune","Kia Carens On Rent in Wagholi Pune"]
],




whychoose: [
    {
        WhyChooseheading: "Premium Kia Carens on Rent in Pune",
        WhyChoosedescription: "Rising Cab Service provides comfortable Kia Carens rental services in Pune for family trips, airport transfers, corporate travel, outstation tours, and group transportation."
    },
    {
        WhyChooseheading: "Modern 7 Seater MPV for Family Travel",
        WhyChoosedescription: "Kia Carens offers spacious seating, premium interiors, advanced features, and excellent ride quality, making it perfect for family and group journeys."
    },
    {
        WhyChooseheading: "Ideal for Local and Outstation Travel",
        WhyChoosedescription: "Book Kia Carens for Pune city travel and popular destinations including Mumbai, Shirdi, Mahabaleshwar, Goa, Nashik, Kolhapur, Lonavala, and Konkan tours."
    },
    {
        WhyChooseheading: "Luxury Comfort with Spacious Cabin",
        WhyChoosedescription: "Passengers enjoy comfortable seating, rear AC vents, ample legroom, modern interiors, and sufficient luggage space for long-distance travel."
    },
    {
        WhyChooseheading: "Perfect for Airport and Corporate Transfers",
        WhyChoosedescription: "Kia Carens is widely preferred for Pune Airport transfers, Mumbai Airport travel, executive transportation, client visits, and business meetings."
    },
    {
        WhyChooseheading: "Doorstep Pickup Across Pune & PCMC",
        WhyChoosedescription: "Pickup services are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Pimpri Chinchwad, Wagholi, and nearby locations."
    },
    {
        WhyChooseheading: "Experienced Drivers for Safe Journeys",
        WhyChoosedescription: "Our professional drivers ensure safe driving, timely pickups, smooth highway travel, and a comfortable experience throughout the trip."
    },
    {
        WhyChooseheading: "Best Choice for Tours, Vacations, and Events",
        WhyChoosedescription: "Kia Carens rentals are perfect for family holidays, pilgrimage tours, weddings, corporate outings, sightseeing trips, and weekend getaways."
    }
]
};

const faqData = [
    {
        question: "Why should I hire a Kia Carens in Pune?",
        answer: "Kia Carens offers spacious seating, premium comfort, modern features, and excellent luggage capacity, making it ideal for family and group travel."
    },
    {
        question: "How many passengers can travel in a Kia Carens?",
        answer: "Kia Carens comfortably accommodates up to 6 or 7 passengers depending on the seating configuration."
    },
    {
        question: "Can I hire Kia Carens for outstation travel?",
        answer: "Yes, Kia Carens vehicles are available for outstation destinations across Maharashtra and neighboring states."
    },
    {
        question: "Is Kia Carens suitable for airport transfers?",
        answer: "Yes, it is one of the preferred vehicles for Pune Airport and Mumbai Airport pickup and drop services."
    },
    {
        question: "Can families book Kia Carens for vacations?",
        answer: "Yes, Kia Carens is an excellent option for family holidays, sightseeing tours, and long-distance journeys."
    },
    {
        question: "Do you provide Kia Carens for corporate travel?",
        answer: "Yes, Kia Carens is widely used for executive transportation, employee travel, client visits, and business meetings."
    },
    {
        question: "Can I book a Kia Carens for one-way travel?",
        answer: "Yes, both one-way and round-trip bookings are available according to customer requirements."
    },
    {
        question: "Is Kia Carens available for pilgrimage tours?",
        answer: "Yes, Kia Carens can be hired for Shirdi, Ashtavinayak, Pandharpur, Tuljapur, Akkalkot, Jyotirlinga, and other religious tours."
    },
    {
        question: "Do you provide pickup from Pune Airport and Railway Station?",
        answer: "Yes, pickups can be arranged from Pune Airport, Railway Station, hotels, offices, and residential locations."
    },
    {
        question: "How can I book a Kia Carens on Rent in Pune?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, website inquiries, or online booking forms with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Pravin Kale",
        feedback:
            "We hired a Kia Carens for our Goa family vacation. The vehicle was spacious, comfortable, and perfect for long-distance travel with luggage.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Madhuri Patil",
        feedback:
            "Our airport transfer and weekend trip were managed perfectly with the Kia Carens. The car was clean, luxurious, and very comfortable for the entire family.",
        rating: 5
    }
];



    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];













const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Kia Carens on Rent in Pune",
"image": "https://www.risingcabservice.com/assets/images/kia-carens-pune.jpg",
"description": "Book Kia Carens on Rent in Pune with Rising Cab Service for comfortable 6–7 seater family travel, airport transfers, and outstation trips. Ideal for group travel with AC comfort, spacious seating, and professional drivers.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹15/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/kia-carens-on-rent-in-pune"
}
};




    return (
        <div>


<Helmet>
  <title>Kia Carens on Rent in Pune | 6–7 Seater Family Cab | +91 9272511548</title>

<meta
 name="description"
 content="Book Kia Carens on Rent in Pune for family trips, airport transfers, and outstation travel. Get spacious 6–7 seater AC cab with driver for safe and comfortable journeys."
/>

<meta
 name="keywords"
 content="kia carens on rent in pune, kia carens rental pune, kia carens cab service pune, kia carens taxi booking pune, kia carens airport cab pune, kia carens outstation cab pune, 6 seater car pune, 7 seater kia carens pune"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>


            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/89.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Kiacarenceonrentinpune;